export default __webpack_public_path__ + "static/media/Lato-ThinItalic.01a7195c.woff2";